const checkImageFader = () => {
    document.querySelectorAll('.sf-image-fader ul').forEach(fader => {
        const items = fader.querySelectorAll('li')
        const bottomPositions = Array.from(items).map(item => {
            const box = item.getBoundingClientRect()
            return box.bottom
        })
        let bottom = null
        for (const b of bottomPositions) {
            if (bottom === null || b > bottom) {
                bottom = b
            }
        }

        const height = bottom - fader.getBoundingClientRect().top
        fader.style.height = `${height}px`
    })
}

export default checkImageFader
